import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { DealerService } from 'src/app/core/services/dealer.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { PaymentEngine } from 'src/app/shared/models/enums/payment-engine.enum';
import { UserRoleEnum } from 'src/app/shared/models/enums/user-role.enum';
import { FocusPayDevice } from 'src/app/shared/models/FocusPay/FocusPayDevice.model';
import { License } from 'src/app/shared/models/license.model';

@Component({
	selector: 'app-on-device-payment',
	templateUrl: './on-device-payment.component.html',
	styleUrls: ['../../../../../commandcenter.scss'],
})
export class OnDevicePaymentComponent implements OnInit, OnDestroy {
	@Input() onDevice: License;
	@Output() onDeviceChange = new EventEmitter<License>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	ethernetDevice: boolean = false;

	paymentEngineAvailableDevices: PaymentDevice[] = [];
	paymentInterfaceOptions: GenericLabelValue[] = [];
	paymentDeviceType: PaymentDevice[] = [
		{
			label: 'e285p',
			value: 'e285p',
			meta: PaymentEngine.ADYEN,
			interface: Interface.IP,
		},
		{
			label: 'p400',
			value: 'p400',
			meta: PaymentEngine.ADYEN,
			interface: Interface.IP,
		},
		{
			label: 'Shift4 BroadPOS',
			value: 'shift4BroadPOS',
			meta: PaymentEngine.SHIFT4,
			interface: Interface.BUILTIN,
		},
		{
			label: 'FocusPay IDTech VP3300 Bluetooth',
			value: 'EMV_VP3300_DATACAP',
			meta: PaymentEngine.DATACAP,
			interface: Interface.BLUETOOTH,
		},
		{
			label: 'FocusPay IDTech VP3300 USB',
			value: 'EMV_VP3300_DATACAP',
			meta: PaymentEngine.DATACAP,
			interface: Interface.USB,
		},
		{
			label: 'FocusPay IDTech VP3300 RS232',
			value: 'EMV_VP3300_DATACAP_RS232',
			meta: PaymentEngine.DATACAP,
			interface: Interface.RS232,
		},
		{
			label: 'FocusPay Pax A920pro',
			value: 'EMV_A920PRO_DATACAP_E2E',
			meta: PaymentEngine.DATACAP,
			interface: Interface.BUILTIN,
		},
		{
			label: 'FocusPay Pax A77',
			value: 'EMV_A77_DATACAP_E2E',
			meta: PaymentEngine.DATACAP,
			interface: Interface.BUILTIN,
		},
		{
			label: 'FocusPay Pax A60',
			value: 'EMV_A60_DATACAP_E2E',
			meta: PaymentEngine.DATACAP,
			interface: Interface.BUILTIN,
		},
		{
			label: 'FocusPay Lane/3000 IP',
			value: 'EMV_LANE3000_DATACAP_E2E',
			meta: PaymentEngine.DATACAP,
			interface: Interface.BUILTIN,
		},
	];

	paymentEngineOptions: GenericLabelValue[] = [
		{ label: 'None', value: PaymentEngine.NONE },
		{
			label: 'FocusPay US',
			value: PaymentEngine.DATACAP,
		},
		{ label: 'FocusPay International', value: PaymentEngine.ADYEN },
		{
			label: 'Shift4',
			value: PaymentEngine.SHIFT4,
		},
		// {
		// 	label: "AuthNet",
		// 	value: PaymentEngine.AUTHNET,
		// 	disabled: this.userService.userSubscription.value.role >= UserRoleEnum.SUPERADMIN,
		// },

		{
			label: 'BroadPOSGeneric',
			value: PaymentEngine.BROADPOSGENERIC,
			disabled: this.userService.userSubscription.value.role >= UserRoleEnum.SUPERADMIN,
		},
	];
	payDeviceSelected: FocusPayDevice;
	focusPayDevicesGrouped: {
		label: string;
		value: string;
		items: {
			label: string;
			value: string;
			disabled?: boolean;
		}[];
	}[] = [];

	focusPayDevices: FocusPayDevice[];

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public userService: UserService,
		public dealerService: DealerService,
		private focuslink: FocuslinkService
	) {}
	ngOnDestroy(): void {}

	ngOnInit(): void {
		if (!this.onDevice.sourceName && this.onDevice.deviceType === 'A930') {
			this.onDevice.sourceName = 'shift4';
		}
		Object.keys(Interface).forEach((key) => {
			this.paymentInterfaceOptions.push({ label: key, value: Interface[key] });
		});
		this.focusPayDeviceBuild();
		this.paymentEngineChange();
		this.onInterfaceChange();
	}

	async focusPayDeviceBuild() {
		console.log(this.venueService.focusPayDeviceList.value);
		if (this.venueService.focusPayDeviceList.value.length === 0) {
			console.log(this.venueService.focusPayDeviceList.observed);
			await this.venueService.focusPayDeviceGet(this.venueService.subscriptionVenue.value.key);
			this.filterFocusPayDevices();
		} else {
			if (this.userService.userSubscription.value.role >= UserRoleEnum.DEALERUSER) {
				this.focusPayDevicesGrouped = [];
				this.filterFocusPayDevices();
			}
		}
	}

	filterFocusPayDevices() {
		const venueDevices = this.venueService.focusPayDeviceList.value;
		const dealerDevices = this.dealerService.dealerFocusPayDeviceList.value?.filter((i) => i.dealerKey === this.onDevice.dealerKey && !i.venueKey);
		const unassignedDevices = this.dealerService.dealerFocusPayDeviceList.value.filter((i) => !i.dealerKey);
		this.focusPayDevicesGrouped.push({
			label: 'Venue Devices',
			value: 'venue',
			items: venueDevices.map((i) => {
				return {
					label: i.deviceId,
					value: i.key,
					disabled: i.venueKey !== this.venueService.subscriptionVenue.value.key,
				};
			}),
		});
		dealerDevices &&
			dealerDevices.length > 0 &&
			this.focusPayDevicesGrouped.push({
				label: 'Dealer Devices',
				value: 'dealer',
				items: dealerDevices.map((i) => {
					return {
						label: i.deviceId,
						value: i.key,
					};
				}),
			});
		unassignedDevices &&
			unassignedDevices.length > 0 &&
			this.focusPayDevicesGrouped.push({
				label: 'Unassigned Devices',
				value: 'unassigned',
				items: unassignedDevices.map((i) => {
					return {
						label: i.deviceId,
						value: i.key,
					};
				}),
			});
	}

	onInterfaceChange() {
		this.paymentEngineChange();
		switch (this.onDevice.ip) {
			case Interface.BLUETOOTH:
				this.paymentEngineAvailableDevices = this.paymentEngineAvailableDevices.filter((i) => i.interface === Interface.BLUETOOTH);
				break;
			case Interface.BUILTIN:
				this.paymentEngineAvailableDevices = this.paymentEngineAvailableDevices.filter((i) => i.interface === Interface.BUILTIN);
				break;
			case Interface.USB:
				this.paymentEngineAvailableDevices = this.paymentEngineAvailableDevices.filter((i) => i.interface === Interface.USB);
				break;
			case Interface.RS232:
				this.paymentEngineAvailableDevices = this.paymentEngineAvailableDevices.filter((i) => i.interface === Interface.RS232);
				break;
			case Interface.IP:
				this.paymentEngineAvailableDevices = this.paymentEngineAvailableDevices.filter((i) => i.interface === Interface.IP);
				break;
		}
	}

	onFocusPayDeviceSelect(event) {
		let focusPayDevice = this.venueService.focusPayDeviceList.value.find((i) => i.key === event.value);

		if (!focusPayDevice) {
			focusPayDevice = this.dealerService.dealerFocusPayDeviceList.value.find((i) => i.key === event.value);
		}
		this.app.confirmation.confirm({
			message: `Change payment device to ${focusPayDevice.deviceId}?`,
			accept: async () => {
				this.app.loading(true);
				await this.changeFocusPayDevice(focusPayDevice);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async changeFocusPayDevice(device: FocusPayDevice) {
		const originalOn = { ...this.onDevice };
		try {
			this.onDevice.sourceName = device.type;
			this.onDevice.serialNumber = device.key;
			this.onDevice.ip = device.ipAddress || undefined;
			if (device.type === 'S1F2' || device.type === 'S1E') {
				this.onDevice.features.updatePaymentDeviceIpAutomatically = true;
				this.onDevice.ip = '127.0.0.1';
			}
			await this.focuslink.licensePut(this.onDevice);
			this.app.devLog(`on-device-payment: Change payment device to ${device.deviceId} for ON Device ${this.onDevice.key}`);
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Error saving ON Device. See log for details.` });
			this.onDevice = originalOn;
			this.app.loading(false);
			return;
		}

		const originalDevice = { ...device };
		try {
			device.venueKey = this.venueService.subscriptionVenue.value.key;
			device.dealerKey = this.venueService.subscriptionVenue.value.dealerKey;
			device.updated = new Date();
			await this.focuslink.focusPayDevicePatch(device);
			this.app.devLog(`on-device-payment: FocusPayDevice Save ${device.deviceId} for ON Device ${this.onDevice.key}`);
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Error saving FocusPayDevice. See log for details.` });
			device = originalDevice;
			this.app.loading(false);
			return;
		}
		this.changesToSaveChange.emit(false);
		this.app.loading(false);
	}

	paymentEngineChange() {
		this.paymentEngineAvailableDevices = this.paymentDeviceType.filter((i) => i.meta === this.onDevice.features.paymentEngine);
	}

	selectDevice(event) {
		if (this.onDevice.features.paymentEngine === PaymentEngine.DATACAP) {
			this.onDevice.serialNumber = this.onDevice.sourceName;
		}

		// const paymentDeviceSelected = this.paymentDeviceType.find((i) => i.value === event.value);
		// if (paymentDeviceSelected && paymentDeviceSelected.interface === Interface.IP) {
		// 	this.ethernetDevice = true;
		// 	return;
		// }
		// this.ethernetDevice = false;
	}
}

class PaymentDevice {
	label: string;
	value: string;
	disabled?: boolean;
	meta?: string;
	interface: Interface;

	public constructor(init?: Partial<PaymentDevice>) {
		Object.assign(this, init);
	}
}

enum Interface {
	USB = 'USB',
	IP = 'IP',
	BUILTIN = 'BUILTIN',
	BLUETOOTH = 'BLUETOOTH',
	RS232 = 'RS232',
}
